import { Loading } from '@perch-labs/shrike';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QueryParamsContext } from '~/providers/query-params';
import { setUtilitySelection } from '~/screens/select-utility/select-utility-utils';
import { SelectUtilityWrapper } from '~/screens/select-utility/select-utility.wrapper';
import { SignupWrapper } from '~/screens/signup/signup.wrapper';
import { SPONSORED_SOLAR_ROUTES } from '~/utils/constants';
import { store } from '~/utils/store';

/**
 *
 * This is a Wrapper component to return the root page of the Sponsored Solar funnel.
 * (i.e) this component decides what to render when you call
 * https://signup.arcadia.com/community-solar-national
 *
 * There are 3 scenarios.
 * 1. call with no zipcode or utilityID as query param. => renders utility Selection.
 * 2. call with zipcode and utilityID as query param. => renders Signup page.
 * 3. call with only zipcode as query param. => renders utility Selection but
 * with zipcode prefilled.
 *
 * Note: The zipcode and utilityId are validated by QueryParamsProvider. Thus,
 * when you receive them here, and they are not 'undefined', then it is
 * guaranteed they are valid.
 */
export const SponsoredSolarRoot = () => {
  const { utilityId, zipCode } = useContext(QueryParamsContext);
  const [isValidUtility, setIsValidUtility] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (zipCode) {
      setIsLoading(true);
      store.set('ZIP_CODE', zipCode);
      if (utilityId) {
        setUtilitySelection(zipCode, utilityId).then(utility => {
          setIsLoading(false);
          if (utility.id) {
            setIsValidUtility(true);
          }
        });
      } else {
        setIsLoading(false);
      }
    }
  }, [utilityId, zipCode]);

  const getRootComponent = () => {
    if (isLoading) {
      return <Loading />;
    }
    if (isValidUtility) {
      return <SignupWrapper />;
    }
    return <SelectUtilityWrapper onUtilitySelect={() => navigate(SPONSORED_SOLAR_ROUTES.SIGNUP)} />;
  };

  return getRootComponent();
};
